import { ValidBusinessObject, ReactAppProcessEnv } from '@iotv/iotv-v3-types'

export { Milliseconds, DataLifeCyclePeriod } from '@iotv/iotv-v3-types'

const projectCode = process.env.projectCode ?? (process.env as ReactAppProcessEnv).REACT_APP_PROJECT_CODE
const stage = process.env.stage ?? (process.env as ReactAppProcessEnv).REACT_APP_DEPLOYMENT_STAGE

const key = `${projectCode}-${stage}`

export const SYSTEM: ValidBusinessObject = {
  type: 'System',
  name: 'System',
  id: `${key}`,
  pk: `System:${key}`,
  sk: `System:${key}`,
}
